import { ChangeDetectionStrategy, Component } from '@angular/core';
import { LoadingService } from './services/loading.service';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    standalone: false,
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class AppComponent {
  title = 'AgroControle';
  constructor(public loadingService: LoadingService) {}
}
